import {
  connect,
  MapDispatchToProps,
  MapStateToProps,
  MergeProps,
} from 'react-redux'
import { actions, getters, selectors } from '@opallabs/wormhole'
import { NormalizedApproval, SubTab, State } from '@opallabs/wormhole/types'
import {
  getAssignmentsParamsForApprovalsByType,
  getPhaseItemParamsForApprovalsByType,
} from './getFiltersByApprovalType'
import { DispatchProps, MergedProps, OwnProps, StateProps } from './types'
import { ApprovalPanel } from '.'

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (
  state
) => {
  const loadingStates = getters.getPersonalPanelLoadingStates(state)

  return {
    // undefined here means we have not attempted to call the API yet
    completedApprovalsLoading: loadingStates
      ? loadingStates.approvals.completed
      : false,
    overdueApprovalsLoading: loadingStates
      ? loadingStates.approvals.overdue
      : false,
    pendingApprovalsLoading: loadingStates
      ? loadingStates.approvals.pending
      : false,
    brandId: selectors.selectCurrentBrandId(state),
    approvals: {
      completed: selectors.selectCompletedApprovals(state),
      overdue: selectors.selectOverdueApprovals(state),
      pending: selectors.selectPendingApprovals(state),
    },
  }
}

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => {
  const getApprovals = (type: string, brandId: string): void => {
    dispatch(
      actions.assignmentsFetchRequest({
        assignmentParams: getAssignmentsParamsForApprovalsByType(
          type,
          ownProps.user.id,
          brandId
        ),
        phaseItemParams: getPhaseItemParamsForApprovalsByType(
          type,
          ownProps.user.id,
          brandId
        ),
        viewKey: `approvals.${type}`,
      })
    )
  }

  return {
    createCheckpoint: (
      subTab: SubTab,
      approvals: NormalizedApproval[]
    ): void => {
      dispatch(
        actions.createCheckpoints({
          items: approvals,
          subTab,
          tab: 'Approval',
        })
      )
    },
    getOverdueApprovals: (brandId: string): void =>
      getApprovals('overdue', brandId),
    getPendingApprovals: (brandId: string): void =>
      getApprovals('pending', brandId),
    getCompletedApprovals: (brandId: string): void =>
      getApprovals('completed', brandId),
    setApprovalPreviewCard: (approval: NormalizedApproval | null): void => {
      ownProps.setApprovalPreviewCard(approval)
    },
  }
}

const mergeProps: MergeProps<
  StateProps,
  DispatchProps,
  OwnProps,
  MergedProps
> = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  getCompletedApprovals: (): void =>
    dispatchProps.getCompletedApprovals(stateProps.brandId),
  getOverdueApprovals: (): void =>
    dispatchProps.getOverdueApprovals(stateProps.brandId),
  getPendingApprovals: (): void =>
    dispatchProps.getPendingApprovals(stateProps.brandId),
})

export const ConnectedApprovalPanel = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ApprovalPanel)
